<script>
export default {
  props: {
    canCheckAll: { type: Boolean, default: false },
    canCompleteStep: { type: Boolean, default: false },
    allProductCompleted: { type: Boolean, default: false },
    currentWorkOrderStepCompleted: { type: Boolean, default: false },
  },
  methods: {
    onCheckAll() {
      this.$emit("check-all");
    },
    onCompleteStep() {
      this.$emit("complete-step");
    },
  },
};
</script>
<template>
  <div class="action-buttons" v-if="canCheckAll || canCompleteStep">
    <b-button
      v-if="canCheckAll"
      variant="primary"
      :disabled="allProductCompleted"
      @click="onCheckAll"
    >
      <i class="mdi mdi-check-all"></i>
      {{ $t("general.checkall") }}
    </b-button>
    <b-button
      v-if="canCompleteStep"
      variant="success"
      :disabled="currentWorkOrderStepCompleted"
      @click="onCompleteStep"
    >
      <i class="mdi mdi-check"></i>
      {{ $t("general.complete") }}
    </b-button>
  </div>
</template>
<style scoped>
.action-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
</style>
